import { createStore } from "vuex";
import app from "../main";
import * as types from "./mutation-types";
import axios from "axios";

const store = createStore({
  state: {lang: "tw"},
  mutations: {
    [types.SET_LANG](state, payload) {
      app.$i18n.locale = payload;
    },
  },
  actions: {
    setLang({ commit }, payload) {
      commit(types.SET_LANG, payload);
    },
    async setLangNew({ commit }, payload) {
      if (payload in app.$i18n.messages) {
        commit(types.SET_LANG, payload);
      } else {
        try {
          const res = await axios.get(`./src/lang/locale/${payload}.json`);
          // const res = await axios.get(`../i18n/${payload}.json`);
          app.$i18n.setLocaleMessage(payload, res.data);
          commit(types.SET_LANG, payload);
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
});
export default store;
